module.exports = __webpack_public_path__ + "img/battery_4green.fab9e7ab.png";